import { render, staticRenderFns } from "./GuWeiSetting.vue?vue&type=template&id=081db392&scoped=true"
import script from "./GuWeiSetting.vue?vue&type=script&lang=js"
export * from "./GuWeiSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081db392",
  null
  
)

export default component.exports